<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@wielink-application/shared/js/mixins/formInput";
import MultipleChecks from "@/pages/components/form/input-only/multiple-checks.vue";

export default {
  mixins: [formInput],
  components: {MultipleChecks, Radio, FormGroup},
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      default: 'horizontal'
    }
  }
}
</script>
<template>
  <FormGroup>
    <template v-if="label" #label>
      {{ label }}
    </template>
    <MultipleChecks
        v-bind="$attrs"
        :form="form"
        :model-value="modelValue"
        :name="name"
        :options="options"
        @update:modelValue="changeModelValueTo"
        :layout="layout"
    />
  </FormGroup>
</template>
